import React from 'react';
import { Heart } from 'lucide-react';

export const WishlistButton = ({ active, onClick, testId, className = '' }) => (
  <button
    type="button"
    data-testid={testId}
    aria-label={active ? 'Remove from wishlist' : 'Save to wishlist'}
    aria-pressed={active}
    onClick={(e) => { e.stopPropagation(); onClick(); }}
    className={`w-10 h-10 rounded-full bg-white/95 shadow flex items-center justify-center transition-transform hover:scale-110 active:scale-95 ${className}`}
  >
    <Heart className={`w-5 h-5 transition-colors ${active ? 'fill-rose-500 text-rose-500' : 'text-gray-500'}`} />
  </button>
);
